var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrField',{attrs:{"field":_vm.field,"loading":_vm.loading},on:{"search-change":function (value) { return _vm.updateValueSearchTerm(value); },"valueChange":function (value) { return _vm.handleValueChange(value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }